import { ArrowLeft } from "lucide-react";

export default function CookiesPolicyPage() {
  return (
    <div className="min-h-screen bg-galvani-bg" data-testid="cookies-policy-page">
      {/* Header */}
      <header className="sticky top-0 z-50 glass py-4 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2 text-galvani-text hover:text-galvani-purple transition-colors" data-testid="back-home-link">
            <ArrowLeft size={18} />
            <span className="font-body text-sm">Volver al inicio</span>
          </a>
          <span className="font-heading font-bold text-galvani-text">Galvani Studios</span>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="font-heading font-extrabold text-4xl sm:text-5xl text-galvani-text mb-4">
          Política de <span className="gradient-text">Cookies</span>
        </h1>
        <p className="font-body text-galvani-textLight mb-12">
          Última actualización: {new Date().toLocaleDateString("es-ES", { day: "2-digit", month: "long", year: "numeric" })}
        </p>

        <div className="space-y-8 font-body text-galvani-text leading-relaxed">

          <section>
            <h2 className="font-heading font-bold text-2xl text-galvani-text mb-4">1. ¿Quién utiliza las cookies?</h2>
            <div className="p-6 rounded-2xl bg-white border border-slate-200 shadow-sm">
              <ul className="space-y-2 text-sm">
                <li><strong>Titular:</strong> GALVANI STUDIOS SL</li>
                <li><strong>N.I.F.:</strong> B42810549</li>
                <li><strong>Domicilio:</strong> C/ Fernando el Católico 57, local — 28015 Madrid</li>
                <li><strong>Email:</strong> <a href="mailto:info@galvanistudios.com" className="text-galvani-blue hover:underline">info@galvanistudios.com</a></li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="font-heading font-bold text-2xl text-galvani-text mb-4">2. ¿Qué son las cookies?</h2>
            <p>Una cookie es un pequeño archivo de información que se descarga en tu dispositivo (ordenador, tablet o teléfono móvil) al acceder a determinadas páginas web. Las cookies permiten a una página web, entre otras cosas, almacenar y recuperar información sobre los hábitos de navegación de un usuario o de su equipo y, dependiendo de la información que contengan y de la forma en que utilice su equipo, pueden utilizarse para reconocer al usuario.</p>
          </section>

          <section>
            <h2 className="font-heading font-bold text-2xl text-galvani-text mb-4">3. Tipos de cookies que utilizamos</h2>

            <div className="space-y-4">
              <div className="p-5 rounded-xl bg-blue-50 border border-blue-200">
                <h3 className="font-heading font-semibold text-galvani-text mb-2">Cookies técnicas (necesarias)</h3>
                <p className="text-sm text-galvani-textLight">Permiten al usuario navegar a través de la web y utilizar sus funcionalidades. Son imprescindibles y no requieren consentimiento.</p>
              </div>

              <div className="p-5 rounded-xl bg-purple-50 border border-purple-200">
                <h3 className="font-heading font-semibold text-galvani-text mb-2">Cookies de análisis</h3>
                <p className="text-sm text-galvani-textLight">Nos permiten cuantificar el número de usuarios y realizar la medición y análisis estadístico de la utilización de nuestra web. Utilizamos <strong>Google Analytics</strong> (gestionado mediante Google Tag Manager).</p>
              </div>

              <div className="p-5 rounded-xl bg-pink-50 border border-pink-200">
                <h3 className="font-heading font-semibold text-galvani-text mb-2">Cookies de marketing</h3>
                <p className="text-sm text-galvani-textLight">Sirven para mostrar publicidad personalizada en función de tu navegación y perfil. Estas cookies solo se activan si das tu consentimiento expreso.</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="font-heading font-bold text-2xl text-galvani-text mb-4">4. Cookies de terceros</h2>
            <div className="overflow-x-auto">
              <table className="w-full text-sm border-collapse">
                <thead>
                  <tr className="bg-slate-100">
                    <th className="p-3 text-left font-heading font-semibold border border-slate-200">Proveedor</th>
                    <th className="p-3 text-left font-heading font-semibold border border-slate-200">Finalidad</th>
                    <th className="p-3 text-left font-heading font-semibold border border-slate-200">Duración</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="p-3 border border-slate-200">Google Analytics</td>
                    <td className="p-3 border border-slate-200">Análisis de uso y estadísticas</td>
                    <td className="p-3 border border-slate-200">Hasta 2 años</td>
                  </tr>
                  <tr className="bg-slate-50">
                    <td className="p-3 border border-slate-200">Google Tag Manager</td>
                    <td className="p-3 border border-slate-200">Gestión de etiquetas y scripts</td>
                    <td className="p-3 border border-slate-200">Sesión</td>
                  </tr>
                  <tr>
                    <td className="p-3 border border-slate-200">MailerLite</td>
                    <td className="p-3 border border-slate-200">Seguimiento de suscriptores</td>
                    <td className="p-3 border border-slate-200">Hasta 1 año</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="font-heading font-bold text-2xl text-galvani-text mb-4">5. ¿Cómo gestionar las cookies?</h2>
            <p className="mb-3">Puedes permitir, bloquear o eliminar las cookies instaladas en tu equipo mediante la configuración de las opciones del navegador. Te dejamos los enlaces oficiales:</p>
            <ul className="list-disc pl-6 space-y-2 text-galvani-textLight">
              <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-galvani-blue hover:underline">Google Chrome</a></li>
              <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noopener noreferrer" className="text-galvani-blue hover:underline">Mozilla Firefox</a></li>
              <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-galvani-blue hover:underline">Safari</a></li>
              <li><a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-galvani-blue hover:underline">Microsoft Edge</a></li>
            </ul>
            <p className="mt-3 text-sm text-galvani-textLight">Ten en cuenta que deshabilitar las cookies puede afectar al funcionamiento correcto de la web.</p>
          </section>

          <section>
            <h2 className="font-heading font-bold text-2xl text-galvani-text mb-4">6. Modificaciones</h2>
            <p>Galvani Studios SL podrá modificar esta Política de Cookies en función de exigencias legislativas o regulatorias. Cuando se produzcan cambios significativos, te lo comunicaremos a través de la web.</p>
          </section>

        </div>

        <div className="mt-16 p-6 rounded-2xl bg-gradient-to-r from-blue-50 to-purple-50 border border-purple-200 text-center">
          <p className="font-body text-galvani-text mb-2">¿Quieres saber más sobre cómo protegemos tu privacidad?</p>
          <a href="/politica-privacidad" className="font-heading font-semibold text-galvani-purple hover:underline">
            Consulta nuestra Política de Privacidad →
          </a>
        </div>
      </main>
    </div>
  );
}
